import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { MathJaxContext } from "better-react-mathjax";
//import './tinymce/build/mathquill.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
  };

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
///export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
      handleClickOpen(){
        setOpen(true);
      }
  }));

  
  const handleClose = () => {
    setOpen(false);
  };

  // {props.contentObj.contentType===4?props.contentObj.contentTitle:null}
  return ((props.contentObj && props.contentObj.autoId>0)?
    <>
      <Dialog fullScreen style={{margin:15}} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
            {(props.contentObj && props.contentObj.contentType==='Text' && props.contentObj.description)?
            <MathJaxContext version={3} config={config}><div className='webtext' dangerouslySetInnerHTML={{ __html: '<h1>'+props.contentObj.contentName+'</h1>'+props.contentObj.description.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
            :<iframe width="100%" height="100%" src={(props.contentObj.contentUrl.indexOf('youtube')>-1)?props.contentObj.contentUrl+"?autoplay=1":props.contentObj.contentUrl} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            }  
      </Dialog>
    </>:<>
      <Dialog fullScreen style={{margin:15}} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
            <iframe width="100%" height="100%" src="https://www.google.com/search?igu=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </Dialog>
    </>
  );

});

export default CustomizedDialogs;
